import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PauseIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const PauseIcon = ({
  size = 14,
  color,
  colorScheme = 'dark',
  className,
}: PauseIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Pause'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 14 14'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect fill={resolvedColor} height='10' rx='1' width='3' x='2.5' y='2' />
      <rect fill={resolvedColor} height='10' rx='1' width='3' x='8.5' y='2' />
    </svg>
  )
}
